if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    if(document.querySelector('.tabs-quad')){
        let tabsQuad = document.querySelectorAll('.tabs-quad__item');
        tabsQuad.forEach((item)=>{
            item.addEventListener('click', ()=>{
                tabsQuad.forEach((tab)=>{
                    tab.classList.remove('active')
                })
                item.classList.add('active');
            })
        })
    }

    $('.gallery-quad__slider').slick({
        arrows: true,
        dots: false,
        slide: '.slide-gallery',
        fade: true,
        speed: 700,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    $('.slider__slider').slick({
        arrows: true,
        dots: false,
        fade: true,
        speed: 700,
        autoplay: true,
        fade:true,
        autoplaySpeed: 7000,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    $('.rooms-quad__slider').slick({
        arrows: true,
        dots: false,
        fade: true,
        speed: 700
    })

    if(document.querySelector('.filter-posts__filter')){
        let tabsFilter = document.querySelectorAll('.filter-posts__filter ul li');
        let itemsFilter = document.querySelectorAll('.filter-posts__item');
        let lastClick = null;

        tabsFilter.forEach((tab)=>{
            tab.addEventListener('click', (e)=>{
                let data = e.target.dataset.filter;
                if(lastClick){
                    lastClick.classList.remove('active');
                }
                tab.classList.add('active');
                itemsFilter.forEach((item)=>{
                    item.classList.toggle('hidden',item.dataset.tag != data);
                });
                lastClick = tab;
            })
        })
        tabsFilter[0].click();
    }

    if(document.querySelector('#start-planing-form')){
        document.querySelector('#start-planing-btn').setAttribute('href', '#start-planing-form');
    }

     // WRAP MODULE TABLES
	document.querySelectorAll('.form-module-wrapper:not(.top-content)').forEach((form) => {
		const tableWrapper = document.createElement('div');
		tableWrapper.classList.add('form-module-wrapper__container','animate-fade','top');
        let confirmation = form.querySelector('.form-module__confirmation');
        let contentForm = form.querySelector('.form-module');
        form.appendChild(tableWrapper);
        tableWrapper.appendChild(confirmation);
        tableWrapper.appendChild(contentForm);
	});

    if(document.querySelector('.text-modules-wrapper')){
        document.querySelectorAll('.text-modules-wrapper .text-modules').forEach((item)=>{
            item.classList.add('animate-fade','top');
        });
    }

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    // GALLERY-FLEX FULLSCRREN MODE
	if (typeof customLightbox !== 'undefined') {
		customLightbox.fullScreen = true;
	}

    if(document.querySelector('.global-sitemap')){
        document.querySelector('.global-sitemap').classList.add('animate-fade','top');
    }

    if(document.querySelector('.js-open-menu')){
        document.querySelectorAll('.js-open-menu').forEach((button)=>{
            button.addEventListener('click',()=>{
                document.getElementById('menu-mobile').classList.add('show');
            })
        })
    }

    if(document.querySelector('.js-close-menu')){
        document.querySelectorAll('.js-close-menu').forEach((button)=>{
            button.addEventListener('click',()=>{
                document.getElementById('menu-mobile').classList.remove('show');
            })
        })
    }

    if(document.querySelector('.js-open-form')){
        document.querySelectorAll('.js-open-form').forEach((button)=>{
            button.addEventListener('click',()=>{
                document.getElementById('form-mobile').classList.add('show');
            })
        })
    }

    if(document.querySelector('.js-close-form')){
        document.querySelectorAll('.js-close-form').forEach((button)=>{
            button.addEventListener('click',()=>{
                document.getElementById('form-mobile').classList.remove('show');
            })
        })
    }

    if(document.querySelector('#form_id-3362')){
     let formPolicy =  document.querySelector('#form_id-3362 .gdpr-wrap');
     let step2 = document.querySelector('.js-step2')
       formPolicy.insertAdjacentHTML("beforebegin", '<div class="js-form-expand">Expand</div>');        
        let ctaFormExpand = document.querySelector(".js-form-expand");
        ctaFormExpand.addEventListener('click' ,() => {
            step2.classList.toggle("hidden");
            ctaFormExpand.classList.toggle("open-expand");
        })
    }

})();